export const HYDRA_TEST_VARIABLE = 'htv'; // currently not a real test; used for documentation and unit testing
export const HYDRA_PUSH_NOTIFICATIONS = 'mpn';
export const HYDRA_BRAND_NAME_SEARCH = 'bnsr'; // [B]rand [N]ame [S]ea[R]ch
export const HYDRA_STREAM_RESPONSE = 'strm'; // Response [Str]ea[m]ing
export const HYDRA_CHECKOUT_SHIPPING_DOWNGRADE = 'csd'; // [C]heckout [S]hipping [D]owngrade
export const HYDRA_FONT_PRELOAD = 'fp'; // [F]ont [P]reload
export const HYDRA_CHECKOUT_STICKY_PLACE_ORDER = 'cspo'; // Sticky Place Order
export const HYDRA_IMAGES_BY_ZYCADA = 'izy'; // [I]mages By [Zy]cada
export const HYDRA_STICKY_ADD_TO_CART = 'stack'; // [ST]icky [A]dd to [C]art with an extra [K]
export const HYDRA_REVIEW_INCENTIVE = 'rice'; // [R]eview [I]n[CE]ntive
export const HYDRA_CHECKOUT_NO_PAYMENT_MSG = 'cnpm'; // [C]heckout No Payment Message
export const HYDRA_PRIME_TWO_DAY_SHIPPING = 'ptds'; // [P]rime [T]wo [D]ay [S]hipping
export const HYDRA_CHECKOUT_PRIVATE_LABEL_CREDIT_CARD = 'cplc'; // [C]heckout [P]rivate [L]abel Credit [C]ard
export const HYDRA_MICROSOFT_SPONSORED_PRODUCTS = 'msft'; // [M]icro[S]o[F][T]
export const HYDRA_NEW_FEDERATED_LOGIN = 'nfl'; // [N]ew [F]ederated [Login]
export const HYDRA_ZFC_DIAMOND = 'zfcd'; // [ZFC] [D]iamond
export const HYDRA_ADDRESS_AUTO_COMPLETE = 'aac'; // [A]ddress [A]uto [C]omplete
export const HYDRA_CHECKOUT_NEXT_DAY_SHIPPING = 'cnds'; // [C]heckout [N]ext [D]ay [S]hipping
export const HYDRA_FILTER_KEYWORD = 'fkw2'; // [F]ilter [K]ey[W]ord
export const HYDRA_BLUE_SKY_PDP = 'oidia'; // [O]ops [I] [D]id [I]t [A]gain
export const HYDRA_ECO_SHIPPING = 'ecs'; // [EC]o [S]hipping
export const HYDRA_SEARCH_QUICK_SHOP = 'sqs'; // [S]earch [Q]uick [S]hop
export const HYDRA_OUTFITS_ON_WEB = 'out'; // [OUT]fits
export const HYDRA_RETURN_STATUS_TRACKING = 'rst'; // [R]eturn [S]tatus [T]racking
export const HYDRA_STARS_ON_ORDER_HISTORY = 'sooh'; // [S]tars [O]n [O]rder [H]istory
export const HYDRA_NAMAGOO = 'nam'; // [Nam]agoo
export const HYDRA_AUTO_FACET_SUGGESTION = 'apfs'; // [A]uto [P]?? [F]acet [S]uggestion
export const HYDRA_SUBSCRIPTION_TEST = 'hzsub'; // [ZSub]scriptionService
export const HYDRA_EMAIL_AUTH_TOKEN = 'eat'; // [E]mail [A]uth [T]oken
export const HYDRA_CHECKOUT_DISCOUNTS = 'cdis'; // [C]heckout [Dis]counts
export const HYDRA_UPLOAD_FROM_INSTAGRAM = 'ufig'; // [U]pload [F]rom [I]nsta[G]ram
export const HYDRA_COLOR_SWATCHES = 'swch';
export const HYDRA_CHECKOUT_AMAZON_PAY = 'camp'; // [C]heckout [Am]azon [P]ay
export const HYDRA_CHECKOUT_AFTER_PAY = 'cafp'; // [C]heckout [Af]ter[P]ay
export const HYDRA_IMPROVED_SIZING_FACET_RECO = 'isfr'; // [I]mproved [S]izing [F]acet [R]ecommendation
